import type { SessionRole } from "@/lib/auth/types";

export function hasRole(roles: SessionRole[], role: SessionRole): boolean {
  return roles.includes("ADMIN") || roles.includes(role);
}

export function canManageAi(roles: SessionRole[]): boolean {
  return hasRole(roles, "AI_ADMIN");
}

export function canReviewKnowledge(roles: SessionRole[]): boolean {
  return hasRole(roles, "KNOWLEDGE_EDITOR");
}

export function canManageUsers(roles: SessionRole[]): boolean {
  return roles.includes("ADMIN");
}

export function canAuditMessenger(roles: SessionRole[]): boolean {
  return hasRole(roles, "AUDITOR");
}

export function canInspectAccess(roles: SessionRole[]): boolean {
  return hasRole(roles, "AUDITOR");
}
